import { claimTicket } from '@jq4race/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MY_ACTIVE_KEY, RETRIEVAL_QUEUE_KEY } from './use-retrieval-queue';

export function useClaimTicket() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => claimTicket(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: RETRIEVAL_QUEUE_KEY });
      void qc.invalidateQueries({ queryKey: MY_ACTIVE_KEY });
    },
    // onError handled by caller (HomePage) to show conflict message + queue refetch on 409
  });
}
